import React from "react";

export default function Team() {
  const leaders = [
    {
      name: "Mr. Shreesh Chandra Srivastava",
      role: "President (CEO)",
      exp: "More than 22 years of experience",
      color: "primary",
      icon: "bi-person-workspace",
    },
    {
      name: "Syed Ejaz Ahmad",
      role: "Project Head",
      exp: "More than 13 years of experience",
      color: "dark",
      icon: "bi-shield-check",
    },
    {
      name: "Prerna Pradhan",
      role: "Quality Team Head",
      exp: "More than 12 years of experience",
      color: "info",
      icon: "bi-award",
    },
  ];

  const specialists = [
    {
      title: "Community Mobilization Specialists",
      count: 2,
      cat: "Field Operations",
      icon: "bi-megaphone",
    },
    {
      title: "Placement Specialists",
      count: 2,
      cat: "Employment",
      icon: "bi-briefcase",
    },
    {
      title: "MIS Specialists",
      count: 1,
      cat: "Data & Systems",
      icon: "bi-database-gear",
    },
    {
      title: "Trainer for Proposed Trades",
      count: 3,
      cat: "Core Instruction",
      icon: "bi-tools",
    },
    {
      title: "English Language Trainers",
      count: 1,
      cat: "Soft Skills",
      icon: "bi-translate",
    },
    {
      title: "Soft Skills & Life Skills Trainers",
      count: 1,
      cat: "Soft Skills",
      icon: "bi-chat-heart",
    },
    {
      title: "IT Literacy Trainers",
      count: 1,
      cat: "Data & Systems",
      icon: "bi-laptop",
    },
    {
      title: "Post Placement Specialists",
      count: 1,
      cat: "Employment",
      icon: "bi-person-check",
    },
  ];

  const totalSpecialists = specialists.reduce(
    (acc, curr) => acc + curr.count,
    0
  );

  return (
    <section
      id="team"
      className="py-5 position-relative"
      style={{
        background:
          "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
      }}
    >
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <div className="d-inline-flex align-items-center gap-2 bg-primary bg-opacity-10 text-primary rounded-pill px-4 py-2 mb-3">
            <i className="bi bi-people-fill"></i>
            <span className="small fw-semibold text-uppercase">
              Human Capital Framework
            </span>
          </div>

          <h2 className="display-5 fw-bold text-dark mb-3">
            Our Leadership & Team Structure
          </h2>

          <p
            className="text-muted mx-auto fs-6"
            style={{ maxWidth: "760px" }}
          >
            Steered by an experienced executive leadership team and
            supported by accredited specialists across mobilization,
            training, quality assurance, MIS, and placement operations.
          </p>
        </div>

        {/* Leadership Cards */}
        <div className="row g-4 justify-content-center mb-5">
          {leaders.map((leader, idx) => (
            <div className="col-lg-4 col-md-6" key={idx}>
              <div className="card border-0 shadow-sm h-100 team-card overflow-hidden">
                <div
                  className={`bg-${leader.color}`}
                  style={{ height: "5px" }}
                ></div>

                <div className="card-body text-center p-4">
                  <div
                    className={`bg-${leader.color} bg-opacity-10 text-${leader.color} rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4`}
                    style={{
                      width: "85px",
                      height: "85px",
                    }}
                  >
                    <i className={`bi ${leader.icon} fs-2`}></i>
                  </div>

                  <h5 className="fw-bold text-dark mb-2">
                    {leader.name}
                  </h5>

                  <span
                    className={`badge bg-${leader.color} px-3 py-2 rounded-pill mb-3`}
                  >
                    {leader.role}
                  </span>

                  <div className="bg-light rounded-3 p-3 border">
                    <small className="text-muted">
                      <i className="bi bi-clock-history me-2"></i>
                      {leader.exp}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Specialists Section */}
        <div className="bg-white rounded-4 shadow-sm p-4 p-lg-5 border">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-4 border-bottom pb-4 mb-4">
            <div>
              <h3 className="fw-bold text-dark mb-2">
                <i className="bi bi-ui-checks-grid text-primary me-2"></i>
                Deployment & Training Specialists
              </h3>

              <p className="text-muted mb-0">
                Dedicated domain experts ensuring successful training,
                mobilization, monitoring, placement, and post-placement
                support.
              </p>
            </div>

            <div className="bg-primary text-white rounded-4 px-4 py-3 shadow-sm">
              <div className="d-flex align-items-center gap-3">
                <i className="bi bi-person-gear fs-2"></i>

                <div>
                  <h3 className="fw-bold mb-0">
                    {totalSpecialists}
                  </h3>
                  <small className="text-white-50 text-uppercase">
                    Total Specialists
                  </small>
                </div>
              </div>
            </div>
          </div>

          {/* Specialist Grid */}
          <div className="row g-3">
            {specialists.map((spec, idx) => (
              <div className="col-xl-3 col-md-4 col-sm-6" key={idx}>
                <div className="specialist-card bg-light border rounded-4 p-3 h-100">
                  <div className="d-flex justify-content-between align-items-start gap-2">
                    <div className="d-flex gap-3">
                      <div className="spec-icon">
                        <i className={`bi ${spec.icon}`}></i>
                      </div>

                      <div>
                        <h6 className="fw-semibold text-dark mb-1 small">
                          {spec.title}
                        </h6>

                        <small className="text-muted text-uppercase">
                          {spec.cat}
                        </small>
                      </div>
                    </div>

                    <span className="badge bg-primary rounded-pill px-3 py-2">
                      {spec.count}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style>{`
        .team-card {
          transition: all 0.3s ease;
          border-radius: 20px;
        }

        .team-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 1rem 2rem rgba(0,0,0,0.08) !important;
        }

        .specialist-card {
          transition: all 0.25s ease;
        }

        .specialist-card:hover {
          background: #ffffff !important;
          transform: translateY(-4px);
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.06);
          border-color: rgba(13,110,253,0.2) !important;
        }

        .spec-icon {
          width: 42px;
          height: 42px;
          min-width: 42px;
          border-radius: 12px;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #0d6efd;
          font-size: 1.1rem;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
        }

        @media (max-width: 768px) {
          .display-5 {
            font-size: 2.2rem;
          }
        }
      `}</style>
    </section>
  );
}